export default __webpack_public_path__ + "static/logo_256_eth-dd9954488023ab47929e6bb7637290ba.svg";